import './App.css';
import Banner from './components/Banner';
import Header from './components/Header';
import About from './components/About';
import Services from './components/Services';
import Contacts from './components/Contacts';
import Footer from './components/Footer';


function App() {

  return (
    <>
      <Header />
      <Banner />
      <About />
      <Services />
      <Contacts /> 
      <Footer />      
    </>
  )
    
    
  
}

export default App;
